import { type ComponentProps } from "react";

import { Link, useOutletContext } from "@remix-run/react";

import { Button } from "~/components";
import { cn } from "~/lib/utils";

import { PackageScreenOutlet } from "../$flow_.$packageId";

export function Footer({ className, ...props }: ComponentProps<"section">) {
    return (
        <section className={cn("flex justify-center gap-4 items-center flex-row-reverse mt-6", className)} {...props} />
    );
}

export function ScreenFormActions({ disabled, intent }: { disabled: boolean; intent: string }) {
    const { previousScreen, isLastScreen } = useOutletContext<PackageScreenOutlet>();

    return (
        <>
            <AddToCartHiddenInput />
            <Button
                className="w-full md:w-52"
                disabled={disabled}
                name="intent"
                value={intent}
                variant={disabled ? "disabled" : "default"}
                type="submit"
            >
                {isLastScreen ? `Add to cart` : `Continue`}
            </Button>
            {previousScreen?.slug ? (
                <Link className="w-full md:w-52" to={`../${previousScreen.slug}`}>
                    <Button className="w-full md:w-52" variant="outline">
                        Previous step
                    </Button>
                </Link>
            ) : null}
        </>
    );
}

export function AddToCartHiddenInput() {
    const { isLastScreen } = useOutletContext<PackageScreenOutlet>();
    if (isLastScreen) {
        return <input type="hidden" name="add-to-cart" value="true" />;
    } else {
        return null;
    }
}
